// extracted by mini-css-extract-plugin
export var container = "styles-module__container___VN4Pz";
export var bg = "styles-module__bg___ECSdF";
export var content = "styles-module__content___hiZhQ";
export var heading = "styles-module__heading___KMdQa";
export var learnMore = "styles-module__learnMore___AofkR";